import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { IoClose } from "react-icons/io5";

const ACTION_META = {
    accept: { label: "Accept", confirmClass: "invoice-action-dialog__btn--confirm-accept" },
    reject: { label: "Reject", confirmClass: "invoice-action-dialog__btn--confirm-reject" },
};

const InvoiceActionDialog = ({ invoice, action, onConfirm, onCancel }) => {
    const meta = ACTION_META[action];

    return (
        <Dialog.Root open onOpenChange={(open) => { if (!open) onCancel(); }}>
            <Dialog.Portal>
                <Dialog.Overlay className="invoice-action-dialog__overlay" />
                <Dialog.Content className="invoice-action-dialog__content" aria-describedby={undefined}>
                    <div className="invoice-action-dialog__header">
                        <Dialog.Title className="invoice-action-dialog__title">
                            {meta.label} Invoice
                        </Dialog.Title>
                        <button
                            type="button"
                            className="invoice-action-dialog__close"
                            aria-label="Close dialog"
                            onClick={onCancel}
                        >
                            <IoClose aria-hidden size={20} />
                        </button>
                    </div>

                    <div className="invoice-action-dialog__body">
                        <dl className="invoice-action-dialog__summary">
                            <div className="invoice-action-dialog__summary-row">
                                <dt>Account Name</dt>
                                <dd>{invoice.accountName}</dd>
                            </div>
                            <div className="invoice-action-dialog__summary-row">
                                <dt>Account ID</dt>
                                <dd>{invoice.accountHccId}</dd>
                            </div>
                            {invoice.billId && (
                                <div className="invoice-action-dialog__summary-row">
                                    <dt>Bill ID</dt>
                                    <dd>{invoice.billId}</dd>
                                </div>
                            )}
                        </dl>
                    </div>

                    <div className="invoice-action-dialog__footer">
                        <button
                            type="button"
                            className="invoice-action-dialog__btn invoice-action-dialog__btn--cancel"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={`invoice-action-dialog__btn ${meta.confirmClass}`}
                            onClick={onConfirm}
                        >
                            Confirm {meta.label}
                        </button>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default InvoiceActionDialog;
